import React from 'react'
import { Label, Accordion, Icon } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { selectQuestion, selectAnswersCount, selectSubAnswersCount } from '../reducers/questions'
import Clearfix from '../utils/Clearfix'
import { QuestionStatusLabel } from './QuestionStatusLabel'
import { hotkey_display } from 'react-keyboard-shortcuts'


class QuestionItem extends React.Component {
    state = { active: false }

    componentDidMount() {
        this.setState({ active: this.props.active })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.active !== this.props.active)
            this.setState({ active: this.props.active })
    }

    handleToggle = () => {
        const { active } = this.state
        this.setState({ active: !active })
        const { onActiveChange } = this.props
        if (onActiveChange)
            onActiveChange(!active)
    }

    render() {
        const { index, question, subAnswersCount, answersCount, actions: Actions, actionsCallbacks, game_id, question_game, state } = this.props
        const { active } = this.state
        return (
            <div>
                <Accordion.Title index={index} active={active} onClick={this.handleToggle}>
                    <Icon name='dropdown' />
                    <Label>{question.topic}</Label> {question.text} <QuestionStatusLabel question_id={question.id}  game_id = {game_id} state = {state} />
                    <br />
                    {active ? null : hotkey_display('ctrl+alt+' + (index + 1))}
                </Accordion.Title>
                <Accordion.Content index={index} active={active}>
                    <p>{question.specs}</p>
                    <div><Label>{answersCount-subAnswersCount} risposte + {subAnswersCount} sub</Label></div>
                    {Actions && active ? <div><Actions index={index} active={active} game_id = {game_id} question_game ={question_game} question={question} state = {state} {...actionsCallbacks} floated='right' /><Clearfix /></div> : null }
                </Accordion.Content>
            </div>
            
        )
    }
}


const mapStateToProps = (state, {question_id, game_id }) => ({
    question: selectQuestion(state, question_id),
    answersCount: selectAnswersCount(state, question_id),
    subAnswersCount: selectSubAnswersCount(state, question_id),
    question_game: state.question_game[game_id+" "+question_id],
    state:state
})

const mapDispatchToProps = dispatch => ({})

export const QuestionsListItem = connect(
    mapStateToProps,
    mapDispatchToProps
)(QuestionItem)




// WEBPACK FOOTER //
// ./src/components/QuestionsListItem.js